export default "__VITE_ASSET__c95a410a__"